import api from "../index";

export const AddVerifyuser = (data) => api.post('trading/trading-create-client',data);
export const GetAllgroupApi = (userId) => api.get(`trading/get-all-group`);
export const GetAllPlanApi = () => api.get(`planmaster/get-all-plans`);
